import CommonUploadFile from '@/components/cards/common-upload-file/common-upload-file';
import CopyClipboard from '@/components/copy-clipboard/copy-clipboard';
import DropdownSelectCheck from '@/components/dropdown-select-check/dropdown-select-check';
import { AdditionalInfoModel, MetricsModel, PartnersModel } from '@/models/console/partners';
import { GradesInfoModal, SubjectInfoModal } from '@/models/taxonomy/category-info';
import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';
import { consoleAPI } from '@/providers/apis/console/console';
import { mediaAPI } from '@/providers/apis/media/media';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { sessionService } from '@/providers/services/auth/session';
import { PARTNERS_TYPE, PARTNERS_TYPE_OBJECT_ARRAY_WISE } from '@/utils/constants';
import { isAPICatchError, isEmptyValue, sortByProperty, sortByPropertyLowerCase } from '@/utils/utils';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { VueEditor } from 'vue2-editor';

@Component({
    name: 'partners-add',
    components: {
        'vue-editor': VueEditor,
        'dropdown-select-check': DropdownSelectCheck,
        'copy-clipboard': CopyClipboard,
        'common-upload-file': CommonUploadFile,
    },
})

export default class PartnerAdd extends Vue {

    public get session() {
        return sessionService.getSession();
    }

    public get partnerType() {
        return this.activePartner;
    }

    public get filteredTenantList() {
        return this.tenantList.filter((item: any) => {
            return item.name.toLowerCase().indexOf(this.tenantSearchText.toLowerCase()) > -1;
        });
    }

    public get partnerDescription() {
        const additionalInfo = this.activePartner.additional_info || {};
        return additionalInfo.notes || '';
      }

    public get isEditModeEnable() {
        return this.isEditMode;
    }

    public get isEnableSecretCodeButton() {
        let value = true;
        if (!isEmptyValue(this.navigatorSecret) && !isEmptyValue(this.navigatorSecret.secretCode)) {
          value = false;
        }
        return value;
    }

    public navigatorSecret = {
        clientId: '',
        secretCode: '',
    };

    public get preSelectedTenant() {
        return this.selectedTenant;
    }

    public get preSelectedCounty() {
        return this.countryDisplayValue;
    }

    public countryDisplayValue = '';

    public get preSelectedState() {
        return this.stateDisplayValue;
    }

    public stateDisplayValue = '';

    public tenantSearchText: any = '';

    public tenantList: any = [];

    public partnerTypes: any = PARTNERS_TYPE;

    public partenrArray: any = PARTNERS_TYPE_OBJECT_ARRAY_WISE;

    public partnerDetails: PartnersModel | any = {
        partner_type: null,
        videos: new Array(1),
    };

    public additionalInfo: AdditionalInfoModel | any = {
        notes: '',
        quotes: new Array(1),
        image_about_project: '',
        what_they_get: '',
        nlc_survey_taken: true,
    };

    public metricsData: MetricsModel | any = {
        data_count: null,
        total_teachers: null,
        total_students: null,
        total_schools: null,
        total_users: null,
    };

    public localCategoryList: any = [];
    public localSubjectList: any = [];
    public localGradeList: any = [];
    public selectedAllGrades: boolean = false;
    public selectedAllSubjects: boolean = false;
    public selectedCategoryInfo: any = [];
    public headerText: any = {};

    public selectedListItems: any = {
        selctedCategoryList: [],
        selectedSubjectList: [],
        selectedGradeLists: [],
    };

    public subjectList: any = [];
    public selectedSubjects: any = [];
    public selectedSubjectsMap: any = [];
    public gradeLists: any = [];

    public categoryLists: any = [];

    public displayTenantList: any = [];

    public countryList: any = [];

    public stateList: any = {};

    public isSubmitted: boolean = false;

    public selectedCountries: number[] = [];

    public selectedState: number[] = [];

    public isEducatorRoute: boolean = false;

    public isDisplayBlock: any = {};

    public isUpdate: boolean = false;

    public isDisplayShortName: boolean = false;

    public newTenant: boolean = false;

    public selectedEducatorType = undefined;

    public selectedTenant: any = {
        name: 'Select tenant',
        id: '',
    };

    public isEditMode: boolean = false;

    public optionsPartnerType = [
        { value: 'lab_schools', text: 'Lab schools' },
        { value: 'schools', text: 'Schools' },
    ];

    public TypeObject = {
        integration_partners: [
            { value: 'LMS', text: 'LMS' },
            { value: 'Tool Provider', text: 'Tool Provider' },
        ],
        funders: [
            { value: 'Govt agency', text: 'Govt agency' },
            { value: 'Philanthropy', text: 'Philanthropy' },
            { value: 'Individual', text: 'Individual' },
            { value: 'HNI', text: 'HNI' },
        ],
    };

    public customToolbar = [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline'], // toggled buttons
        [
            { align: '' },
            { align: 'center' },
            { align: 'right' },
            { align: 'justify' },
        ],
        ['code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image', 'video'],
    ];

    @Prop({default: {}})
    public activePartner: any;

    @Prop({default: false})
    private isDetailsMode: any;

    private offset: number = 0;

    private limit: number = 20;

    private tenantDataCount: number = 0;

    private isLoading: boolean = false;

    private imageModal: any = {};
    // -------------------------------------------------------------------
    // Properties

    @Watch('selectedCountries')
    public onChangeCountries() {
        this.getPreSelectedCounty();
        this.fetchStateList();
    }

    @Watch('selectedState')
    public onChangeState() {
        setTimeout(() => {
            this.getPreSelectedCounty();
        }, 500);
    }

    @Watch('$route')
    public checkRouter() {
        this.$emit('onSwitch', 'curriculum-provider');
    }

    // --------------------------------------------------------------------------
    // Hooks

    public created() {
        this.scrollToTop();
        this.fetchCountries();
        if (this.isDetailsMode) {
            const partnerId = this.partnerType.partner_id;
            if (partnerId) {
                this.isUpdate = true;
                this.fetchPartnerDetails(partnerId);
            }
            this.getCreatedOAuth();
        } else {
            this.isUpdate = false;
            this.isEditMode = true;
            this.partnerDetails.partner_type = this.partnerType;
        }
        this.$store.dispatch('categorySubjectStore/fetchCategoryList');
        this.isEducatorRoute = this.partnerType === 'educators' ? true : false;
        this.getCategoryLists();
        const params: any = {
            offset: 0,
            limit: 500,
        };
        this.displayOrHideBlock();
        this.getTenantList(params);
        this.getExistingTenant();
    }


    public mounted() {
        this.scrollEventAttach();
    }

    // -----------------------------------------------------------------------------
    // Actions

    public onSubmit() {
        const that = this;
        that.scrollToTop();
        const params: PartnersModel = {
            contact_name: this.partnerDetails.contact_name,
            contact_email: this.partnerDetails.contact_email,
            organization_name: this.partnerDetails.organization_name,
            organisation_head: this.partnerDetails.organisation_head,
            partner_type: this.partnerType === 'educators' ?
                this.selectedEducatorType : this.partnerDetails.partner_type,
            primary_phone: this.partnerDetails.primary_phone,
            website: this.partnerDetails.website,
            intro: this.partnerDetails.intro,
            videos: this.partnerDetails.videos,
            additional_info: this.additionalInfo,
            metrics: this.metricsData,
            logo: this.partnerDetails.logo || '',
            status: 'active',
            is_visible: true,
            address: this.partnerDetails.address,
            states: this.selectedState,
            countries: this.selectedCountries,
            super_admin_name: '',
            super_admin_email: '',
            images: [],
            tenant: this.selectedTenant.id,
            subject_classifications: this.subjectClassifications(this.selectedCategoryInfo),
            grades: this.getGroupIds(this.selectedCategoryInfo),
            short_name: this.partnerDetails.short_name,
        };
        this.isSubmitted = true;
        this.$validator.validate().then(async (valid) => {
            if (!this.isCustomValidationSuccess(params)) {
                return;
            }
            if (valid && params.tenant) {
                that.isLoading = true;
                if (that.imageModal && that.imageModal instanceof File) {
                    const thumb: any = that.imageModal;
                    const thumbFile = await mediaAPI.uploadFile(thumb, 'image');
                    params.logo = thumbFile.filename;
                }
                if (that.isUpdate) {
                    consoleAPI.updatePartner(params, that.partnerType.partner_id).then((data: any) => {
                        if (!isAPICatchError(data)) {
                            that.showConfirmationModal();
                        }
                        that.isLoading = false;
                    });
                    return;
                }
                consoleAPI.insertPartner(params).then((data) => {
                    if (!isAPICatchError(data)) {
                        that.showConfirmationModal();
                    }
                    that.isLoading = false;
                });
            }
        });
    }

    public isCustomValidationSuccess(params: any) {
        if ((this.selectedCountries && this.selectedCountries.length === 0) ||
        (this.selectedState && this.selectedState.length === 0) ||
        (this.isDisplayBlock.isCategory && this.selectedCategoryInfo && this.selectedCategoryInfo.length === 0)
        ) {
            return false;
        } else {
            return true;
        }
    }

    public onUpdateFile() {
        if (typeof(this.imageModal) !== 'string' && this.imageModal instanceof File) {
            this.partnerDetails.logo = URL.createObjectURL(this.imageModal);
        }
    }

    public onAddRows(newArrayList: any) {
        newArrayList.push('');
    }

    public onDeleteRows(remove: any) {
        this.partnerDetails.videos.splice(remove, 1);
    }
    public onDeleteAdditionalInfoRows(remove: any) {
        this.additionalInfo.quotes.splice(remove, 1);
    }


    public onGoBack() {
        if (this.isEditModeEnable && this.isUpdate) {
            this.isEditMode = false;
        } else {
            this.$emit('onSwitch', 'curriculum-provider');
        }
    }


    // ----------------------------------------------------------------------------
    // Methods

    public fetchPartnerDetails(partnerId: string) {
        this.isLoading = true;
        consoleAPI.fetchPartnerDetails(partnerId).then((partner: any) => {
            this.isLoading = false;
            if (!isAPICatchError(partner)) {
                this.partnerDetails = partner;
                this.selectedCountries = partner.countries.map((item: any) => item.id);
                this.selectedState = partner.states.map((item: any) => item.id);
                this.metricsData = Object.assign(this.metricsData, partner.metrics);
                this.additionalInfo = Object.assign(this.additionalInfo, partner.additional_info);
                this.getPreSelectedCounty();
            }
        });
    }

    public inputValidator(errors: any, keyName: string) {
        return this.isSubmitted && errors.has(keyName);
    }

    public fetchCountries() {
        taxonomyAPI.fetchTaxonomyCountry().then((countries: any) => {
            this.countryList = countries.groups ? countries.groups : [];
            // this.preSelectedCounty = this.countryList.find((item))
        });
    }

    public fetchStateList() {
        const selectedCountries = this.selectedCountries;
        selectedCountries.forEach((countryId: number) => {
            if (!this.stateList[countryId]) {
                taxonomyAPI.fetchTaxonomyState({ id: countryId }).then((states: any) => {
                    const statesList = states.groups ? states.groups : [];
                    this.$set(this.stateList, countryId, statesList);
                });
            }
        });
    }

    public hasSelectedCountry(key: any) {
        return this.selectedCountries.indexOf(parseInt(key, 10)) !== -1;
    }

    public onSearchCategory(value: any) {
        if (!isEmptyValue(value)) {
            const localCategoryList = [...this.categoryLists].filter(
                (item: any) => item.title.toLowerCase().startsWith(value.toLowerCase()));
            this.localCategoryList = localCategoryList;
        } else {
            this.localCategoryList = this.categoryLists;
        }
    }

    public onSearchSubject(value: any) {
        if (!isEmptyValue(value)) {
            this.localSubjectList = [...this.subjectList].filter(
                (item: any) => item.title.toLowerCase().startsWith(value.toLowerCase()));
        } else {
            this.localSubjectList = this.subjectList;
        }
    }

    public onSearchGrades(value: any) {
        if (!isEmptyValue(value)) {
            this.localGradeList = [...this.gradeLists].filter(
                (item: any) => item.title.toLowerCase().startsWith(value.toLowerCase()));
        } else {
            this.localGradeList = this.gradeLists;
        }
    }

    public onSelectCategoryList(addedTool: any) {
        this.clearSubjectChecks();
        if (!isEmptyValue(addedTool.id)) {
            const filterdCat = this.categoryLists.find((catItem: any) => catItem.id === addedTool.id);
            sortByProperty(filterdCat.subjectList, 'title', 'ASC');
            this.subjectList = filterdCat.subjectList;
            this.localSubjectList = filterdCat.subjectList;
        } else {
            // this.addedTool.subject = null;
            // this.addedTool.grade = null;
            this.subjectList = [];
            this.localSubjectList = [];
        }
    }

    public selectedCategeoryItemList(selctedCategoryList: any) {
        this.selectedListItems.selctedCategoryList = selctedCategoryList;
        if (selctedCategoryList && selctedCategoryList.length > 1) {
            this.selectedAllSubjects = true;
        } else {
            this.selectedAllSubjects = false;
        }
    }

    public selectedSubjectItemList(selectedSubjectList: any) {
        this.selectedListItems.selectedSubjectList = selectedSubjectList;
        if (selectedSubjectList && selectedSubjectList.length > 1) {
            this.selectedAllGrades = true;
        } else {
            this.selectedAllGrades = false;
        }
    }

    public selectedGradeItemList(selectedGradeLists: any) {
        this.selectedListItems.selectedGradeLists = selectedGradeLists;
    }

    public getCategoryLists() {
        this.categoryLists = this.$store.state.categorySubjectStore.categoryLists;
        this.localCategoryList = this.$store.state.categorySubjectStore.categoryLists;
        // console.log('this.localCategoryList', this.localCategoryList);
    }

    public clearSelectedCategroyInfo() {
        this.selectedListItems.selctedCategoryList = [];
        this.selectedListItems.selectedSubjectList = [];
        this.selectedListItems.selectedGradeLists = [];
        this.clearSubjectChecks();
        this.headerText = {
            category: 'Select Category',
            subject: 'Select Subject',
            grade: 'Select Grades',
        };
    }

    public clearSubjectChecks() {
        this.selectedSubjectsMap = [];
        this.selectedSubjects = [];
        // this.addedTool.subject = null;
        // this.addedTool.grade = null;
        this.gradeLists = [];
        this.subjectList = [];
        this.localSubjectList = [];
        this.localGradeList = [];
        this.selectedAllGrades = false;
    }

    public onSelectSubject(newProviderInfo: any) {
        if (newProviderInfo === 'All') {
            this.selectedAllGrades = true;
            this.gradeLists = [];
            this.localGradeList = [];
        } else {
            // this.addedTool.grade = null;
            this.gradeLists = [];
            if (!isEmptyValue(newProviderInfo.id)) {
                const filterdSubject = this.subjectList.find((subItem: any) => subItem.id === newProviderInfo.id);
                this.getGradeCourseList(filterdSubject);
            }
        }
    }

    public getGradeCourseList(subject: any) {
        taxonomyAPI.fetchTaxonomyCourse(subject).then((courses) => {
            this.gradeLists = courses;
            this.localGradeList = courses;
        });
    }

    public addSelectedItems() {
        if (this.selectedListItems.selctedCategoryList && this.selectedListItems.selctedCategoryList.length > 0) {
            this.createDatacategoryInfo();
            this.clearSelectedCategroyInfo();
        }
    }

    public createDatacategoryInfo() {
        if (this.selectedListItems.selctedCategoryList && this.selectedListItems.selctedCategoryList.length > 0) {
            if (this.selectedCategoryInfo && this.selectedCategoryInfo.length > 0) {
                const catIndex = this.selectedCategoryInfo.findIndex((item: any) => {
                    return item.id === this.selectedListItems.selctedCategoryList[0].id;
                });
                if (catIndex !== -1) {
                    this.createSubjectDataInfo(catIndex);
                } else {
                    this.selectedListItems.selctedCategoryList.map((codes: any) => {
                        this.selectedCategoryInfo.push({
                            id: codes.id,
                            code: codes.code,
                            title: codes.title,
                            subject: this.createSubjectDataInfo(),
                        });
                    });
                }

            } else {
                this.selectedListItems.selctedCategoryList.map((codes: any) => {
                    this.selectedCategoryInfo.push({
                        id: codes.id,
                        code: codes.code,
                        title: codes.title,
                        subject: this.createSubjectDataInfo(),
                    });
                });
            }

        }
        this.$set(this, 'selectedCategoryInfo', this.selectedCategoryInfo);
    }

    public createSubjectDataInfo(catIndex?: any) {
        if (catIndex >= 0) {
            if (this.selectedListItems.selectedSubjectList &&
                this.selectedListItems.selectedSubjectList.length === 0) {
                this.selectedCategoryInfo[catIndex].subject = [];
            }
            const subIndex = this.selectedCategoryInfo[catIndex].subject.findIndex((itemSub: any) => {
                return itemSub.id === this.selectedListItems.selectedSubjectList[0].id;
            });

            if (subIndex !== -1) {
                this.createGradeDataInfo(catIndex, subIndex);
            } else {
                if (this.selectedListItems.selectedSubjectList &&
                    this.selectedListItems.selectedSubjectList.length > 0) {
                    this.selectedListItems.selectedSubjectList.map((codes: any) => {
                        this.selectedCategoryInfo[catIndex].subject.push({
                            id: codes.id,
                            code: codes.code,
                            title: codes.title,
                            count: codes.count,
                            description: codes.description,
                            frameworkId: codes.frameworkId,
                            sequenceId: codes.sequenceId,
                            isActive: codes.isActive,
                            grades: this.createGradeDataInfo(),
                        });
                    });
                }
            }
        } else {
            const subject: SubjectInfoModal[] = [];
            if (this.selectedListItems.selectedSubjectList &&
                this.selectedListItems.selectedSubjectList.length > 0) {
                this.selectedListItems.selectedSubjectList.map((codes: any) => {
                    subject.push({
                        id: codes.id,
                        code: codes.code,
                        title: codes.title,
                        count: codes.count,
                        description: codes.description,
                        frameworkId: codes.frameworkId,
                        sequenceId: codes.sequenceId,
                        isActive: codes.isActive,
                        grades: this.createGradeDataInfo(),
                    });
                });
            }
            return subject;
        }
    }

    public createGradeDataInfo(catIndex?: any, subIndex?: any) {
        if (catIndex >= 0 && subIndex >= 0) {
            this.selectedListItems.selectedGradeLists.filter((selectedTitle: any) =>
                this.selectedCategoryInfo[catIndex].subject[subIndex].grades.findIndex((subjectItem: any) =>
                    subjectItem.id === selectedTitle.id && subjectItem.title === selectedTitle.title) < 0)
                .forEach((sub: any) => {
                    const grades: GradesInfoModal = {
                        id: sub.id,
                        code: sub.code,
                        sequence_id: sub.sequence_id,
                        title: sub.title,
                    };
                    this.selectedCategoryInfo[catIndex].subject[subIndex].grades.push(grades);
                });
        } else {
            const grades: GradesInfoModal[] = [];
            if (this.selectedListItems.selectedGradeLists &&
                this.selectedListItems.selectedGradeLists.length > 0) {
                this.selectedListItems.selectedGradeLists.map((codes: any) => {
                    grades.push({
                        id: codes.id,
                        code: codes.code,
                        sequence_id: codes.sequence_id,
                        title: codes.title,
                    });
                });
            }
            return grades;
        }
    }

    public subjectClassifications(subjectData: any) {
        const sendData: any = {};
        subjectData.map((data: any) => {
            const subjects: any[] = [];
            data.subject.map((subject: any) => {
                subjects.push(subject.id);
            });
            sendData[data.id] = subjects;
        });
        return sendData;
    }

    public getGroupIds(subjectData: any) {
        const sendData: any = {};
        subjectData.map((data: any) => {
            data.subject.map((subject: any) => {
                const grades: any[] = [];
                subject.grades.map((grade: any) => {
                    grades.push(grade.id);
                });
                sendData[subject.id] = grades;
            });
        });
        return sendData;
    }

    public deleteRow(index: any) {
        this.selectedCategoryInfo.splice(index, 1);
    }

    private displayOrHideBlock() {
        const partnerType: any = this.partnerType;
        const showHide = {
            categoryBlock: ['content_developers'],
            ContToolAlgo: ['researchers'],
            userCount: ['implementers', 'educators', 'integration_partners'],
            schoolCount: ['implementers', 'educators'],
            // funders:[],
            // integration_partners:[],
            // researchers:[],
            // educators:[],
            // implementers:[]
        };
        this.isDisplayBlock.isCategory = showHide.categoryBlock.includes(partnerType);
        this.isDisplayBlock.isContToolAlgo = showHide.ContToolAlgo.includes(partnerType);
        this.isDisplayBlock.isUserCount = showHide.userCount.includes(partnerType);
        this.isDisplayBlock.isSchoolCount = showHide.schoolCount.includes(partnerType);
    }

    private getTenantList(params: any) {
        if (this.tenantList.length !== 0 && this.offset >= this.tenantDataCount) {
            return;
        }
        adminUtilsAPI.fetchTenantList(params).then((data: any) => {
            sortByPropertyLowerCase(data.list, 'name', 'ASC');
            if (!this.newTenant) {
                const newTenant = {
                    id: 'new_tenant',
                    name: 'Add new tenant',
                };
                data.list.unshift(newTenant);
                this.newTenant = false;
            }
            this.tenantList = this.tenantList.concat(data.list);
            this.tenantDataCount = data.total_count;
            if (this.partnerDetails && this.partnerDetails.tenant) {
                this.selectedTenant = this.tenantList.find((item: any) => item.id === this.partnerDetails.tenant);
            }
        });
    }

    private selectTenantItem(item: any) {
        const tenantDd =  (this.$refs as any).tenantDd;
        if (tenantDd) {
            tenantDd.hide(true);
        }
        this.selectedTenant = item;
        this.partnerDetails.tenantId = item.id;
        this.tenantSearchText = '';
        if (item.id === 'new_tenant') {
            this.isDisplayShortName = true;
        } else {
            this.isDisplayShortName = false;
            this.partnerDetails.short_name = null;
        }
    }

    private getExistingTenant() {
        if (this.partnerDetails && this.partnerDetails.tenant) {
            this.selectedTenant = this.tenantList.find((item: any) => item.id === this.partnerDetails.tenant);
            if (this.selectedTenant && isEmptyValue(this.selectedTenant.id)) {
                this.selectedTenant =  { name: 'Select tenant', id: '' };
            }
        }
    }

    private onScroll() {
        // this.offset += this.limit;
        // const params: any = {
        //     offset: this.offset,
        //     limit: 500,
        // };
        // this.getTenantList(params);
    }

    private scrollEventAttach() {
        const tenantDd: any = document.querySelector('#tenantDd .dropdown-menu');
        if (tenantDd) {
            tenantDd.addEventListener('scroll', (event: any) => {
                const { scrollHeight, scrollTop, clientHeight } = event.target;
                if (Math.abs(scrollHeight - clientHeight - scrollTop) < 1) {
                    this.onScroll();
                }
            });
        }
    }

    private onEditClick() {
        this.isEditMode = true;
    }

    private onNewSecret() {
        if (!isEmptyValue(this.navigatorSecret.secretCode)) {
          return;
        }
        if (!isEmptyValue(this.activePartner.tenant_id)) {
          const payload = {
            tenant_id: this.activePartner.tenant_id,
            partner_id: this.activePartner.partner_id,
          };
          adminUtilsAPI.fetchOAthClientSecret(payload).then((data: any) => {
            const code: any = {
              client_id: data.client_id,
              client_secret: data.client_secret,
            };
            this.navigatorSecret.clientId = data.client_id;
            this.navigatorSecret.secretCode = data.client_secret;
          });
        }
    }

    private getCreatedOAuth() {
        const params = {
            tenant_id: this.activePartner.tenant_id,
            partner_id: this.activePartner.partner_id,
        };
        if (!isEmptyValue(this.activePartner.tenant_id)) {
            adminUtilsAPI.fetchOAuthConfig(params).then((dataResp: any) => {
            if (dataResp && dataResp.length > 0) {
                const data = dataResp[0];
                this.navigatorSecret.clientId = data.client_id;
                this.navigatorSecret.secretCode = data.client_secret;
            }
            });
        }
    }

    private hideConfirmationModal() {
        this.$bvModal.hide('confirmation-profile');
    }

    private showConfirmationModal() {
        this.isLoading = false;
        this.$bvModal.show('confirmation-profile');
    }

    private dismiss() {
        this.$emit('onSwitch', 'curriculum-provider');
    }

    private scrollToTop() {
        window.scrollTo({ top: 0});
    }

    private async getPreSelectedCounty() {
        const valueArrayCountry: any = [];
        const valueArrayState: any = [];
        let displayCountryValue = '';
        let displayStateValue = '';
        const countrylist = this.countryList;
        const stateSelected = this.selectedState;
        const selectedCountry = this.selectedCountries;
        for await (const iterator of selectedCountry) {
            if (stateSelected && stateSelected.length > 0) {
                const states: any = await taxonomyAPI.fetchTaxonomyState({ id: iterator });
                const statesList = states.groups ? states.groups : [];
                for (const state of stateSelected) {
                    const stateOp = statesList.find((stateItem: any) => state === stateItem.id);
                    if (stateOp && stateOp.name && !valueArrayState.includes(stateOp.name)) {
                        valueArrayState.push(stateOp.name);
                    }
                    if (valueArrayState.length > 1) {
                        displayStateValue = `${valueArrayState[0]} (+${valueArrayState.length - 1})`;
                    } else {
                        displayStateValue = valueArrayState.join(',');
                    }
                }
            }
            const op = countrylist.find((item: any) => iterator === item.id);
            if (op && op.name && !valueArrayCountry.includes(op.name)) {
                valueArrayCountry.push(op.name);
            }
        }
        if (valueArrayCountry.length > 1) {
            displayCountryValue = `${valueArrayCountry[0]} (+${valueArrayCountry.length - 1})`;
        } else {
            displayCountryValue = valueArrayCountry.join(',');
        }
        this.countryDisplayValue = this.selectedCountries && this.selectedCountries.length > 0 ? displayCountryValue : '';
        this.stateDisplayValue = this.selectedState && this.selectedState.length > 0 ? displayStateValue : '';
    }
}
